import React from 'react';

const Preloader = (props) =>{
    return(
        <div className="cssload-container">
            <div className="cssload-loading">
                <i/><i/><i/><i/>
            </div>
        </div>
    )
};

export default Preloader;


// WEBPACK FOOTER //
// ./src/components/Preloader.js